// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "劳动与创造",
      "tec": "刘英杰",
      "week": "15周",
      "add": "教学楼D座324经管"
    },
    [
      {
        "sub": "机械制造技术基础",
        "tec": "谭越",
        "week": "1-12周",
        "add": "教学楼D座213经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘英杰",
        "week": "15周",
        "add": "教学楼D座324经管"
      }
    ],
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "马仕海张翼",
      "week": "1-8周",
      "add": "教学楼D座226经管"
    },
    {
      "sub": "电子商务",
      "tec": "孙敬延",
      "week": "1-12周",
      "add": "教学楼D座222经管"
    },
    0
  ],
  "2": [
    {
      "sub": "劳动与创造",
      "tec": "刘英杰",
      "week": "15周",
      "add": "教学楼D座324经管"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李健",
        "week": "1-8周",
        "add": "教学楼C座114教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "李健",
        "week": "9-11,13周",
        "add": "教学楼C座114教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘英杰",
        "week": "15周",
        "add": "教学楼D座324经管"
      }
    ],
    0,
    0,
    {
      "sub": "就业创业指导",
      "tec": "马彤兵",
      "week": "7-11周",
      "add": "教学楼D座226经管"
    }
  ],
  "3": [
    {
      "sub": "工程经济学",
      "tec": "徐鸣哲",
      "week": "1-12周",
      "add": "教学楼D座223经管"
    },
    {
      "sub": "系统仿真",
      "tec": "郭艳秋",
      "week": "1-12周",
      "add": "实训楼C座310"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "机械制造技术基础",
      "tec": "谭越",
      "week": "1-12周",
      "add": "教学楼D座213经管"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李健",
        "week": "1-8周",
        "add": "教学楼C座115教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "李健",
        "week": "9-11,13周",
        "add": "教学楼C座115教务"
      }
    ],
    0,
    0
  ],
  "5": [
    {
      "sub": "系统仿真",
      "tec": "郭艳秋",
      "week": "1-4周",
      "add": "实训楼C座310"
    },
    {
      "sub": "工程经济学",
      "tec": "徐鸣哲",
      "week": "1-12周",
      "add": "教学楼D座213经管"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
